module.exports = __webpack_public_path__ + "static/media/orange_theater_tn.0bd245e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/orange_theater_tn.jpg
// module id = 748
// module chunks = 0